/** Shared MUI sx for Trade Blotter filter dropdowns. */
export const tradeBlotterFilterControlSx = (theme) => ({
  borderRadius: 1,
  backgroundColor: theme.palette.background.paper,
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.divider,
  },
});

/**
 * Outlined toolbar action button styling (gradient hover).
 * @param {object} theme - MUI theme
 * @param {string} color - primary hex color
 * @param {string} hoverLight - lighter hex for gradient start
 * @param {object} [options]
 * @param {string} [options.hoverTextColor="#ffffff"]
 * @param {string} [options.hoverGradientEnd] - gradient end color (defaults to `color`)
 * @param {boolean} [options.disabledUsesMutedBorder=false] - delete/archive idle state
 */
export const tradeBlotterOutlinedActionSx = (
  theme,
  color,
  hoverLight,
  options = {}
) => {
  const {
    hoverTextColor = "#ffffff",
    hoverGradientEnd = color,
    disabledUsesMutedBorder = false,
  } = options;
  const idleBorder = disabledUsesMutedBorder
    ? theme.palette.action.disabled
    : color;
  const idleColor = disabledUsesMutedBorder
    ? theme.palette.action.disabled
    : color;

  return {
    borderRadius: "12px !important",
    textTransform: "none !important",
    fontWeight: "600 !important",
    px: "16px !important",
    borderColor: `${idleBorder} !important`,
    color: `${idleColor} !important`,
    background: "transparent !important",
    backgroundImage: "none !important",
    "&:hover": {
      borderColor: `${color} !important`,
      background: `linear-gradient(135deg, ${hoverLight} 0%, ${hoverGradientEnd} 100%) !important`,
      backgroundImage: "none !important",
      color: `${hoverTextColor} !important`,
    },
    "&.MuiButton-outlined": {
      borderColor: `${color} !important`,
      color: `${color} !important`,
      background: "transparent !important",
      backgroundImage: "none !important",
    },
    "&:disabled": {
      borderColor: `${theme.palette.action.disabled} !important`,
      color: `${theme.palette.action.disabled} !important`,
      background: "transparent !important",
      backgroundImage: "none !important",
    },
  };
};
